module.exports = __webpack_public_path__ + "assets/logo.d5018a0115cf3749750fa4da0ec46459.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 89
// module chunks = 0